export default "__VITE_ASSET__e8d68f8e__"